// queries/useGetAPIKey.ts
"use client";
import { useQuery } from "@tanstack/react-query";
import { fetch } from "libs";
import { GET_API_KEY } from "api";
import { APIKeyResponse } from "types";

function fetchAPIKey(): Promise<APIKeyResponse> {
  return fetch(GET_API_KEY);
}

// React Query hook
export function useGetAPIKey() {
  return useQuery({
    queryKey: ["useAPIKey"],
    queryFn: async () => await fetchAPIKey(),
  });
}

export default useGetAPIKey;
